<template>
    <div style="width: 100%;" :class="passwordThemeColor">
        <ul id="password-validation">
            <li v-bind:class="{ is_valid: contains_eight_characters }">8 Characters</li>
            <li v-bind:class="{ is_valid: contains_number }">Contains Number</li>
            <li v-bind:class="{ is_valid: contains_lowercase }">Contains Lowercase</li>
            <li v-bind:class="{ is_valid: contains_uppercase }">Contains Uppercase</li>
            <li v-bind:class="{ is_valid: contains_special_character }">Contains Special Character</li>
            <li v-bind:class="{ is_valid: same_confirm_password }">Matches Confirm Password</li>
        </ul>
        <qw-input class="form-field mb-3"
                  name="password"
                  icon="fas fa-unlock"
                  placeholder="Password"
                  autocomplete="off"
                  @input="checkPassword"
                  @buttonClick="show = !show"
                  :endIcon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  :type="show ? 'text' : 'password'"
                  v-model="form.password"/>
        <qw-input class="form-field mb-3"
                  name="confirmPassword"
                  icon="fas fa-unlock"
                  placeholder="Confirm Password"
                  @input="checkConfirmPassword"
                  autocomplete="off"
                  :endIcon="confirmShow ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @buttonClick="confirmShow = !confirmShow"
                  :type="confirmShow ? 'text' : 'password'"
                  v-model="form.confirmPassword"/>
        <button class="form-button" @click="emit()" v-if="status === 'ready'"
                :disabled="hasMissingValidation">{{buttonName}}
        </button>
        <div class="form-error mb-3" v-if="hasErrors">
            <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import QwInput from "@/components/global/form/QWInput";
    import Validator from "../utils/Validator";

    export default {
        name: "set-password",
        components: {
            QwInput
        },
        props: {
            buttonName: {
                required: true,
                type: String
            },
            status: {
                required: true,
                type: String
            },
            passwordThemeColor: {
                required: true,
                type: String
            },
        },
        data() {
            return {
                errors: [],
                show: false,
                confirmShow: false,
                password_length: 0,
                contains_eight_characters: false,
                contains_number: false,
                contains_uppercase: false,
                contains_lowercase: false,
                contains_special_character: false,
                valid_password: false,
                same_confirm_password: false,
                form: {
                    password: "",
                    confirmPassword: "",
                },
                validationRules: {
                    password: "required",
                    confirmPassword: "required"
                }
            };
        },
        mounted() {
            this.bindEnterKey();
        },
        destroyed() {
            this.unbindEnterKey();
        },
        methods: {
            bindEnterKey() {
                document.onkeydown = (e) => {
                    let keyCode = e.keyCode === undefined ? e.key : e.keyCode;
                    switch (keyCode) {
                        case 13:
                            this.emit();
                            break;
                    }
                }
            },
            unbindEnterKey() {
                document.onkeydown = null;
            },
            checkPassword() {
                console.log(this.status);
                this.password_length = this.form.password.length;
                const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

                if (this.password_length >= 8) {
                    this.contains_eight_characters = true;
                } else {
                    this.contains_eight_characters = false;
                }

                this.contains_number = /\d/.test(this.form.password);
                this.contains_uppercase = /[A-Z]/.test(this.form.password);
                this.contains_lowercase = /[a-z]/.test(this.form.password);
                this.contains_special_character = format.test(this.form.password);

                if (this.contains_eight_characters === true &&
                    this.contains_special_character === true &&
                    this.contains_uppercase === true &&
                    this.contains_number === true &&
                    this.contains_lowercase === true) {
                    this.valid_password = true;
                } else {
                    this.valid_password = false;
                }
            },
            checkConfirmPassword() {
                this.same_confirm_password = this.form.confirmPassword === this.form.password;
            },
            emit() {
                this.errors = [];
                let validator = new Validator();
                validator.validate(this.form, this.validationRules);
                if (validator.hasErrors()) {
                    this.errors = validator.list();
                    return;
                }
                this.$emit('submit', this.form.password);
            }
        },
        computed: {
            hasMissingValidation() {
                return !(this.valid_password && this.same_confirm_password)
            },
            hasErrors() {
                return !!(this.errors && this.errors.length);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-button {
        display: block;
        width: 100%;
        padding: 7px 0;
        font-weight: 700;
        font-family: $raleway;
        border: 2px solid $white !important;
        border-radius: 25px;
        background-color: $white;

        i {
            margin: 0 10px 0 0;
        }

        &:hover {
            background-color: transparent;
        }

        &:disabled {
            border: 2px solid $light-gray !important;
            background-color: $light-gray;
            color: $dark-gray;

            &:hover {
                background-color: $light-gray;
            }
        }
    }

    .is_valid:before {
        width: 100%;
    }

    ul {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    li {
        margin-bottom: 8px;
        font-size: 12px;
        position: relative;
    }

    .white-li {
        .form-button {
            color: $primary;

            &:hover {
                color: $white;
            }
        }

        .is_valid {
            //color: rgba(136, 152, 170, 0.8);
            color: white;
        }

        li {
            color: white;
        }

        li:before {
            background: white;
        }
    }

    .grey-li {
        .form-button {
            color: $dark-gray;

            &:hover {
                color: $extra-darker-gray;
            }
        }

        .is_valid {
            //color: rgba(136, 152, 170, 0.8);
            color: $dark-gray;
        }

        li {
            color: $dark-gray;
        }

        li:before {
            background: $dark-gray;
        }
    }


    li:before {
        content: "";
        width: 0%;
        height: 2px;
        position: absolute;
        left: 0;
        top: 50%;
        display: block;
        font-size: 12px;
        transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .checked {
        animation: draw 0.5s ease forwards;
    }

    @keyframes draw {
        to {
            stroke-dashoffset: 0;
        }
    }

    #password-validation {
        width: 100%;
        text-align: left;
    }

</style>
